<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">编辑职位</span>
      </p>

      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">招聘类型</p>
        <p style="color: #8a8a8ab3">
          <!--<input v-if="list.work_nature==1" class="inforNameInput" type="text" v-model="list.work_nature" value="w" placeholder="请填写" >-->
          <input v-if="list.work_nature==1" class="inforNameInput" type="text" v-model="work" value="list.work_nature" placeholder="请填写"  readonly="readonly" >

        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位名称</p>
        <p style="color: #8a8a8ab3"> <input class="inforNameInput" type="text" v-model="list.name" placeholder="请填写" readonly="readonly" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位类型</p>
        <p style="color: #8a8a8ab3"> <input class="inforNameInput" type="text" v-model="list.position_type"  placeholder="请填写"  readonly="readonly"></p>
      </div>
      <!--<div class="inforWork">-->
        <!--<div class="inforWorkDiv">-->
          <!--<span style="font-size: 14px;color:#DEDEDE " @click="show = true" >工作经验</span>-->
          <!--&lt;!&ndash;<van-cell is-link title="基础用法" @click="show = true" />&ndash;&gt;-->

          <!--&lt;!&ndash;<span>3-5年</span>&ndash;&gt;-->
          <!--&lt;!&ndash;<span v-model="haha">你好</span>&ndash;&gt;-->
          <!--<span class="" v-if="list.work_year==1">不限</span>-->
          <!--<span class="" v-else-if="list.work_year==2" >1年以下</span>-->
          <!--<span class="" v-else-if="list.work_year==3" >1-3年</span>-->
          <!--<span class="" v-else-if="list.work_year==4" >3-5年</span>-->
          <!--<span class="" v-else-if="list.work_year==5" >5-10年</span>-->
          <!--<span class="" v-else-if="list.work_year==6" >10年以上</span>-->
        <!--</div>-->
        <!--<div class="inforWorkCenter">-->
          <!--<span style="font-size: 14px;color:#DEDEDE" >最低学历</span>-->
          <!--&lt;!&ndash;<span>3-5年</span>&ndash;&gt;-->

          <!--<span class="" v-if="list.edu==1" >不限</span>-->
          <!--<span class="" v-else-if="list.edu==2"  >大专</span>-->
          <!--<span class="" v-else-if="list.edu==3" >本科</span>-->
          <!--<span class="" v-else-if="list.edu==4" >硕士</span>-->
          <!--<span class="" v-else-if="list.edu==5" >博士</span>-->
        <!--</div>-->
        <!--<div class="inforWorkDiv">-->
          <!--<span style="font-size: 14px;color:#DEDEDE">薪资范围</span>-->
          <!--<span>{{qwxz}}</span>-->
        <!--</div>-->
    <!--</div>-->

      <div class="inforWork">
        <div class="center">
          <div>
            <span @click="show=true" style="font-size: 14px;color:#DEDEDE " >工作经验</span>

          </div>
          <div>
            <van-dropdown-menu placeholder="请填写" >
              <van-dropdown-item  v-model="list.work_year"  :options="option1" placeholder="请填写"/>
              <!--<van-dropdown-item v-model="value2" :options="option2" />-->
            </van-dropdown-menu>
          </div>
          <!--<span>3年</span>-->

        </div>
        <!--<div class="inforWorkCenter">-->
        <div class="center inforWorkCenter">
          <span style="font-size: 14px;color:#DEDEDE">最低学历</span>
          <van-dropdown-menu placeholder="请填写" >
            <van-dropdown-item v-model="list.edu" :options="option2" placeholder="请填写"/>
            <!--<van-dropdown-item v-model="value2" :options="option2" />-->
          </van-dropdown-menu>
          <!--<span style="font-size: 14px;color:#DEDEDE"  v-model="list.edu">工作经验</span>-->
          <!--<span>3-5年</span>-->
        </div>
        <div class="center">
          <span style="font-size: 14px;color:#DEDEDE" v-model="list.salary">薪资范围</span>
          <!--<span>3-5年</span>-->
          <van-dropdown-menu placeholder="请填写" >
            <van-dropdown-item v-model="list.salary" :options="option3" placeholder="请填写"/>
            <!--<van-dropdown-item v-model="value2" :options="option2" />-->
          </van-dropdown-menu>
        </div>
     </div>
      <div class="inforName">
        <p class="inforNameTop">职位关键词</p>
        <p> <input class="inforNameInput" type="text" v-model="list.keywords" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位描述</p>
        <p >
          <textarea style="width: 100%;height: 5rem"  v-model="list.desc" placeholder="请填写"></textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位亮点</p>
        <p> <input class="inforNameInput" type="text" v-model="list.welfare" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所属部门</p>
        <p> <input class="inforNameInput" type="text" v-model="list.department" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">工作城市</p>
        <p> <input class="inforNameInput" type="text" v-model="list.city" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">详细地址</p>
        <p> <input class="inforNameInput" type="text" v-model="list.address" placeholder="请填写" ></p>
      </div>
      <div>

      </div>

    </div>
    <div class="inforName">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="sveRemPositioner()">保存并发布</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        aaa:"1",
        name:'',
        work:'',
        qwxz:"",
        list:{
          work_nature:"",
          name:'',
          position_type:'',
          work_year:'',
          edu:"",
          salary:'',
          keywords:'',
          desc:'',
          welfare:'',
          department:'',
          city:'',
          address:''
        },
        show: false,
        actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' },
          { name: '选项三' },{ name: '选项三' },{ name: '选项三' },{ name: '选项三' },
        ],
//        value1: 0,
//        value2: 0,
//        value3: 0,
//        value4: 0,
        option1: [
          { text: '请选择', value: 0 },
          { text: '不限', value: 1 },
          { text: '一年以下', value: 2 },
          { text: '1-3年', value: 3 },
          { text: '3-5年', value: 4},
          { text: '5-10年', value: 5 },
          { text: '10年以上', value: 6 },
        ],
        option2: [
          { text: '请选择', value: 0, },
          { text: '不限', value: 1 },
          { text: '大专', value: 2 },
          { text: '本科', value: 3 },
          { text: '硕士', value: 4 },
          { text: '博士', value: 5 },
        ],
        option3: [
          { text: '请选择', value: 0 },
          { text: '1-2K', value: 1 },
          { text: '2-4K', value: 2 },
          { text: '4-6K', value: 3 },
          { text: '6-8K', value: 4 },
          { text: '8-10K', value: 5 },
          { text: '10-15K', value: 6 },
          { text: '15-20K', value: 7 },
          { text: '20-25K', value: 8 },
          { text: '25-35K', value: 9 },
          { text: '35-50K', value: 10 },
          { text: '50-70K', value: 11 },
          { text: '70-100K', value: 12 },
          { text: '100K以上', value: 13 },
        ],
      }
    },
    mounted(){
      this.getComPositioner()
    },
    methods:{
      onSelect(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = false;
        Toast(item.name);
      },
      backHistory(){
        this.$router.go(-1)
      },
      sveRemPositioner(){
        console.log(this.data)
        this.$api.sveRemPosition({
          "data[work_nature]": this.list.work_nature,
          "data[name]": this.list.name,
          "data[position_type]": this.list.position_type,
          "data[work_year]": this.list.work_year,
          "data[edu]": this.list.edu,
          "data[salary]": this.list.salary,
          "data[keywords]":this.list.keywords,
          "data[desc]":this.list.desc,
          "data[welfare]":this.list.welfare,
          "data[department]":this.list.department,
          "data[city]":this.list.city,
          "data[address]":this.list.address,
          "jobid":this.$route.query.id
        }).then(res=>{
          if(res.status==200){

            this.$toast("保存成功")
            this.$router.push({
                path:"/comDetailsPosition",
                query:{
                  id:this.$route.query.id
                }
              }
              )
          }
//          this.$router.push("/editResume")
        }).catch(err=>{
        })
      },
      getComPositioner(){
        console.log(this.aaa)
        this.$api.getComPosition({
          "jobid":this.$route.query.id,
//          "id":this.$route.params.id
        })
          .then(res=>{
            if(res.status==200){
              this.list=res.data?res.data[0]:{}
              this.leader=this.list.leader?this.list.leader:{}
//              this.list=res.data?res.data[0]:{}
              switch (this.list.salary){
                case 1:
                  this.qwxz = '1K-2K';
                  break;
                case 2:
                  this.qwxz = '2K-4K';
                  break;
                case 3:
                  this.qwxz = '4K-6K';
                  break;
                case 4:
                  this.qwxz = '6K-8K';
                  break;
                case 5:
                  this.qwxz = '8K-10K';
                  break;
                case 6:
                  this.qwxz = '10K-15K';
                  break;
                case 7:
                  this.qwxz = '15K-20K';
                  break;
                case 8:
                  this.qwxz = '20K-25K';
                  break;
                case 9:
                  this.qwxz = '25K-35K';
                  break;
                case 10:
                  this.qwxz = '35K-50K';
                  break;
                case 11:
                  this.qwxz = '50K-70K';
                  break;
                case 12:
                  this.qwxz = '70K-100K';
                  break;
                case 13:
                  this.qwxz = '100K以上';
                  break;
                default:
                  this.qwxz = '';
                  break;
              }
              switch (this.list.work_nature){
                case 1:
                  this.work="全职";
                  break;
                case 2:
                  this.work="兼职";
                case 3:
                  this.work="兼职";
                break;

                default:
                  this.work="";
                break

              }
            }
          })
          .catch(res=>{
          })
      },
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  /*.inforWork{*/
    /*display: flex;*/
    /*justify-content: space-around;*/
    /*align-items: center;*/
    /*border-bottom: solid 1px #DEDEDE;*/

  /*}*/
  /*.inforWork span{*/
    /*display: block;*/

  /*}*/
  /*.inforWork div{*/
    /*text-align: center;*/
    /*!*padding: 8px 10px;*!*/
    /*margin: 8px 10px;*/
  /*}*/
  /*.inforWorkCenter{*/
    /*border-left: solid 1px #DEDEDE;*/
    /*border-right: solid 1px #DEDEDE;*/
    /*width: 30%;*/
  /*}*/
  /*.inforWorkDiv{*/
    /*width: 30%;*/
  /*}*/


  .inforWork{
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: solid 1px #DEDEDE;
    padding: 20px 0;
  }
  .inforWork span{
    display: block;

  }
  .inforWork div{
    text-align: center;
    /*padding: 8px 10px;*/
    /*margin: 8px 10px;*/
  }
  .inforWorkCenter{
    width: 35%;
    border-left: solid 1px #DEDEDE;
    border-right: solid 1px #DEDEDE;
  }
  /deep/ .van-dropdown-menu__bar{
    box-shadow: 0 2px 12px rgba(0,0,0,0)
  }
  .center{
    /*width: 30%;*/
  }
  /deep/ .type .van-dropdown-menu__item{
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
  }
  input::-webkit-input-placeholder{
    color:#323233;
    /*font-size: 14px;*/
  }
  input{
    font-size: 14px;
  }
  /deep/.van-ellipsis{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/remPosition.vue